import { mobileBreakPointSize } from 'app.styled/media'
import useMediaQuery from './useMediaQuery'

const useIsMobile = (): boolean => {
  const matches = useMediaQuery(`(max-width: ${mobileBreakPointSize}px)`)
  return matches
}

export default useIsMobile
